module.exports = __webpack_public_path__ + "img/pc-loader.cfd36f58.svg";